export const getSpotifyArtistErrorMessage = (err: any): string => {
  if (err?.status === 404) {
    return 'No artist found.';
  }
  return "Something went wrong while searching for the artist's name. Please try again.";
};
